import styled from 'styled-components';

export const SegmentLabel = styled.span`
  width: 13.7rem;
  display: flex;
  align-items: center;
  padding: 0.5rem 0.6rem;
  border-radius: 0.8rem;
  background-color: ${(p) => (p.green ? p.green : "#eef4fd")};
  span {
    &:last-child {
      font-size: 1.2rem;
      font-weight: 600;
      color: #141823;
    }
  }
`;

export const DefaultIcon = styled.span`
  width: 1.6rem;
  height: 1.6rem;
  background-color: #9b9b9b;
  border-radius: 50%;
  display: inline-flex;
  flex-direction: row;
`;